import React from 'react'
import Main from '../components/SGCPage/Main'

const SGCPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default SGCPage